import { useEffect, useState } from 'react';

function FileUploadMultiple(props) {

  const { onFilesChanged } = props;
  const [fileList, setFileList] = useState(null);

  const handleFileChange = e => {
    setFileList(e.target.files);
  };

  useEffect(() => {

    onFilesChanged(fileList);

  }, [ fileList, onFilesChanged ]);

  const files = fileList ? [...fileList] : [];

  return (
    <div>
      <input type="file" onChange={handleFileChange} multiple className="form-control" />

      <ul className="mt-3" style={{"listStyle": "none"}}>
        {files.map((file, i) => (
          <li key={i}>
            {file.name}
          </li>
        ))}
      </ul>

    </div>
  );
}

export default FileUploadMultiple;
